export default __webpack_public_path__ + "static/media/logo-icon.d5697f95.svg";